import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Navigation from '../../Layouts/Navigation/Navigation';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBuilding, faChartLine, faCircleCheck, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { BASE_URL } from '../../utils/constants';

const AdminCartera = () => {
  const navigate = useNavigate();
  const [towers, setTowers] = useState([]);
  const [stats, setStats] = useState({ total_apartamentos: 0, al_dia: 0, en_mora: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const headers = { Authorization: `Bearer ${token}` };

    Promise.all([
      axios.get(`${BASE_URL}/towers`, { headers }),
      axios.get(`${BASE_URL}/cartera/stats`, { headers }),
    ])
      .then(([towersRes, statsRes]) => {
        setTowers(towersRes.data);
        setStats(statsRes.data);
      })
      .catch(err => console.error('Error cargando cartera:', err))
      .finally(() => setLoading(false));
  }, []);

  const pctMora = stats.total_apartamentos > 0
    ? Math.round((stats.en_mora / stats.total_apartamentos) * 100)
    : 0;

  const towerGradients = [
    'from-amber-500 to-orange-600',
    'from-rose-500 to-red-600',
    'from-violet-500 to-purple-600',
    'from-sky-500 to-blue-600',
    'from-teal-500 to-cyan-600',
    'from-lime-500 to-green-600',
  ];

  if (loading) {
    return (
      <>
        <Navigation />
        <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center">
          <div className="animate-spin rounded-full h-12 w-12 border-4 border-amber-500 border-t-transparent"></div>
        </div>
      </>
    );
  }

  return (
    <>
      <Navigation />
      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 p-4 sm:p-6 lg:p-8">
        <div className="max-w-7xl mx-auto">

          {/* Header */}
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-gray-800 flex items-center gap-3">
              <FontAwesomeIcon icon={faChartLine} className="text-amber-500" />
              Cartera
            </h1>
            <p className="text-gray-500 mt-1">Seguimiento al estado de pagos de administración por unidad.</p>
          </div>

          {/* Stats globales */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-10">
            <div className="bg-white rounded-2xl shadow p-5 flex items-center gap-4">
              <div className="bg-gray-100 rounded-xl p-3">
                <FontAwesomeIcon icon={faBuilding} className="text-gray-500 text-xl" />
              </div>
              <div>
                <p className="text-sm text-gray-500">Total unidades</p>
                <p className="text-2xl font-bold text-gray-800">{stats.total_apartamentos}</p>
              </div>
            </div>
            <div className="bg-white rounded-2xl shadow p-5 flex items-center gap-4">
              <div className="bg-green-100 rounded-xl p-3">
                <FontAwesomeIcon icon={faCircleCheck} className="text-green-600 text-xl" />
              </div>
              <div>
                <p className="text-sm text-gray-500">Al día</p>
                <p className="text-2xl font-bold text-green-600">{stats.al_dia}</p>
              </div>
            </div>
            <div className="bg-white rounded-2xl shadow p-5 flex items-center gap-4">
              <div className="bg-red-100 rounded-xl p-3">
                <FontAwesomeIcon icon={faTriangleExclamation} className="text-red-500 text-xl" />
              </div>
              <div>
                <p className="text-sm text-gray-500">En mora</p>
                <p className="text-2xl font-bold text-red-500">{stats.en_mora}</p>
                {pctMora > 0 && (
                  <p className="text-xs text-gray-400">{pctMora}% del total</p>
                )}
              </div>
            </div>
          </div>

          {/* Torres */}
          <h2 className="text-xl font-bold text-gray-700 mb-4">Selecciona una torre</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {towers.map((tower, index) => (
              <button
                key={tower.id_torre}
                onClick={() => navigate(`/controlCartera/${tower.id_torre}`)}
                className={`bg-gradient-to-br ${towerGradients[index % towerGradients.length]}
                  rounded-2xl p-6 text-left shadow-lg hover:shadow-xl hover:scale-[1.02]
                  transition-all duration-200 cursor-pointer`}
              >
                <div className="flex items-start justify-between">
                  <div>
                    <p className="text-white/80 text-xs font-medium uppercase tracking-wider mb-1">Torre</p>
                    <h3 className="text-white text-xl font-bold">{tower.nombre}</h3>
                  </div>
                  <div className="bg-white/20 rounded-xl p-2">
                    <FontAwesomeIcon icon={faBuilding} className="text-white text-lg" />
                  </div>
                </div>
                <p className="text-white/70 text-sm mt-4">
                  Ver estado de cartera →
                </p>
              </button>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminCartera;
